export default "__VITE_ASSET__BnHtu3iQ__"